import './Title.css';

const Title = props => {
    return(
        <h1 className="formElements-title">{props.text}</h1>
    )
}

export default Title;